import React from 'react';
import cn from 'classnames';
import {Link} from 'react-router-dom';

import {isTranslate} from 'shared/lib/lang';

import styles from './LinkButton.module.scss';

export interface LinkButtonProps {
    href: string,
    className?: string,
    children: React.ReactNode,
    primary?: boolean,
    block?: boolean,
}

const LinkButton: React.FC<LinkButtonProps> = ({href, className, children, primary, block}) => {
    return (
        <Link
            to={href}
            className={cn(
                'btn',
                styles.btn,
                styles.linkButton,
                primary && (isTranslate() ? styles.enPrimary : styles.ruPrimary),
                block && styles.block,
                className,
            )}
        >
            {children}
        </Link>
    );
};

export default LinkButton;
